import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { environment } from "src/environments/environment";

export enum Styles {
  Error = "background-color:firebrick; color:white",
  Warn =  "background-color:darkorange; color:black",
  Info =  "background-color:darkblue; color:ivory",
  Debug = "background-color:#222; color:#00bba4",
}

export enum LogLevel {
  All = 0,
  Debug = 1,
  Info = 2,
  Warn = 3,
  Error = 4,
  Off = 5,
}

/**
 * Debug categories that can be individually toggled in environment.loggingOptions.debugCategories.
 * Pass a category to logger.debug() to gate that message behind its toggle.
 */
export type DebugCategory = 'auth' | 'worker' | 'markers' | 'http' | 'location' | 'ui';

const options = environment.loggingOptions;
const logToRest = options.logToRest;
const logToFile = options.logToFile;
const logToLocalStorage = options.logToLocalStorage;
const debugCategories: Record<string, boolean> = options.debugCategories || {};
const localStorageLog = 'cvv-log';

@Injectable({
  providedIn: "root",
})
export class LoggerService {
  constructor() {}

  level: LogLevel = LogLevel[environment.loggingOptions.loglevel];

  private writeToLog(message: string, level: LogLevel, obj?: Record<string, unknown> | Array<any>): void {
    const datetime = new Date().toLocaleString();

    if (this.shouldLog(level)) {

      // Console Log OBJECT if one was passed in...
      if (obj !== null && obj !== undefined) {

        console.log(`%c${LogLevel[level].toUpperCase()}: ${datetime}: ${message}`, Styles[LogLevel[level]], obj);

      } else {

        // Console Log STRING if no OBJECT was passed in...
        console.log(`%c${LogLevel[level].toUpperCase()}: ${datetime}: ${message}`, Styles[LogLevel[level]]);

        // For Remote Logging
        if (logToFile) {
          if (this.level === LogLevel.All){
            console.log(`%c${LogLevel[level].toUpperCase()}: ${datetime}: LOGGING TO FILE: ${message}`, Styles[LogLevel[level]]);
          }
          // implement logging to a file with webworker
        }
        if (logToRest) {
          if (this.level === LogLevel.All){
            console.log(`%c${LogLevel[level].toUpperCase()}: ${datetime}: LOGGING TO REST: ${message}`, Styles[LogLevel[level]]);
          }
          // implement logging to Rest API with webworker?
        }
        if (logToLocalStorage) {
          if (this.level === LogLevel.All){
            console.log(`%c${LogLevel[level].toUpperCase()}: ${datetime}: LOGGING TO LOCAL STORAGE: ${message}`, Styles[LogLevel[level]]);
          }
          // implement logging to local storage with webworker or no?
        }

      }
    }
  }

  debug(msg: string, objOrCategory?: any, category?: DebugCategory): void {
    // Support both: debug(msg, obj, category) and debug(msg, category)
    let obj: any;
    let cat: DebugCategory;
    if (typeof objOrCategory === 'string' && !category) {
      cat = objOrCategory as DebugCategory;
      obj = undefined;
    } else {
      obj = objOrCategory;
      cat = category;
    }
    // If a category is specified, only log if that category is enabled
    if (cat && !debugCategories[cat]) {
      return;
    }
    this.writeToLog(msg, LogLevel.Debug, obj);
  }

  info(msg: string, obj?: any):void {
    this.writeToLog(msg, LogLevel.Info, obj);
  }

  warn(msg: string, obj?: any):void {
    this.writeToLog(msg, LogLevel.Warn, obj);
  }

  error(msg: string, obj?: any):void {
    this.writeToLog(msg, LogLevel.Error, obj);
  }

  private shouldLog(level: LogLevel): boolean {
    let ret = false;
    if ((level >= this.level && level !== LogLevel.Off) || this.level === LogLevel.All) {
      ret = true;
    }
    return ret;
  }





logToLocalStorage(entry: any): Observable<boolean> {// Append log entry to local storage
    let ret = false;
    let values: any[];
    try {
        values = JSON.parse(localStorage.getItem(localStorageLog)) || [];// Get previous values from local storage
        values.push(entry);// Add new log entry to array
        localStorage.setItem(localStorageLog, JSON.stringify(values));// Store array into local storage
        ret = true;// Set return value
    } catch (ex) {
        console.log(ex);// Display error in console
    }
    return of(ret);
}


clearLocalStorageLog(): Observable<boolean> {// Clear all log entries from local storage
    localStorage.removeItem(localStorageLog);
    return of(true);
}

getLocalStorageSize(): void{
  const localStorageSpace = function() {
    let total = 0;
    for (const x in localStorage) {
        const amount = ((localStorage[x].length*16) / (8*1024));
        if (!isNaN(amount) && localStorage.hasOwnProperty(x)) {
          if(x === localStorageLog){
            console.log(x, localStorage.getItem(x), amount.toFixed(2) + ' KB');
          }
            total += amount;
        }
    }
    return total.toFixed(2);
  };
  console.log(localStorageSpace() + ' KB');
}


}
